module.exports = __webpack_public_path__ + "static/img/zhy.427beb2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhy.jpg
// module id = Vb6C
// module chunks = 1